module.exports = __webpack_public_path__ + "img/13.9699646c.jpg";